export function addCommasToNumber(number: number | string, decimalPlaces = 2): string {
  try {
    if (Number.isNaN(+number)) {
      throw new Error('Not a valid number')
    }

    // Nhân số với 10^decimalPlaces, sau đó làm tròn xuống bằng Math.floor
    const multiplier = 10 ** decimalPlaces
    const roundedNumber = Math.floor(+number * multiplier) / multiplier

    const numberWithCommas: string = roundedNumber.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',')

    return numberWithCommas
  } catch {
    return '0'
  }
}

export function convertAddress(locationInfo, hideAddress = false) {
  if (!locationInfo) return ''
  const { address, district, ward, province } = locationInfo
  const getValue = (data: string | { title: string; id: number }) => {
    return typeof data === 'string' ? data : data?.title ?? ''
  }

  const result = [getValue(address), getValue(ward), getValue(district), getValue(province)]
  if (hideAddress) result.shift()

  return result.filter((item) => item).join(', ')
}

export function openInNewTab(url: string) {
  const newWindow = window.open(url, '_blank');

  // Check if popup was blocked (Safari and other browsers)
  if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
    return false; // Popup was blocked
  }

  return true; // Popup opened successfully
}

export function openInNewTabWithFallback(url: string, fallbackCallback?: () => void) {
  // Try to open in new tab first
  const opened = openInNewTab(url);

  if (!opened && fallbackCallback) {
    // If popup was blocked, execute fallback
    fallbackCallback();
  }

  return opened;
}

export function createPreOpenedWindow() {
  // Pre-open a blank window to avoid popup blocking
  // This must be called during user interaction (click event)
  return window.open('', '_blank');
}

export function removeVietnameseTones(str: string) {
  if (str === undefined || str === null) return ''
  return str
    .normalize("NFD") // Chuyển ký tự về dạng chuẩn Unicode
    .replace(/[\u0300-\u036f]/g, "") // Loại bỏ dấu thanh
    .replace(/đ/g, "d") // Thay thế ký tự "đ"
    .replace(/Đ/g, "D")
    .replace(/[^a-zA-Z0-9\s]/g, "") // Loại bỏ ký tự đặc biệt
    .replace(/\s+/g, " ") // Chuẩn hóa khoảng trắng
    .trim();
}

export function dynamicFontText(text: string, startAtChar = 11) {
  if (!text) return 100;
  const numberOfCharsAdjusted = text.length;
  const numberOfCharToConsiderForCalculation = Math.max(
    0,
    numberOfCharsAdjusted - (startAtChar - 1)
  );
  const fontSizeInPercent = Math.max(
    50,
    100 - 3.5 * numberOfCharToConsiderForCalculation
  );
  return fontSizeInPercent;
}

export function formatDateToUnderscore(date) {
  const pad = (n) => String(n).padStart(2, '0');
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());
  return `${year}_${month}_${day}_${hours}_${minutes}_${seconds}`;
}
